module.exports = __webpack_public_path__ + "static/media/cnMatoriato.e1734ffd.webp";